<template>
    <section>
        <ui-choose-unit-reserve-modal name="choose-unit-reserve"></ui-choose-unit-reserve-modal>
    </section>
</template>

<script>
    import { uiChooseUnitReserveModal } from '@/components/ui-facilita/modals'

    export default {
        components: {
            uiChooseUnitReserveModal
        },

        mounted() {
            const parameters = this.$route.query

            this.$root.$emit('modal-open-choose-unit-reserve', {
              isIframe: true,
              id: parameters.id,  
              column: parameters.column,
              funnel_stage_id: parameters.funnel_stage_id,
              funnel_stage_status_id: parameters.funnel_stage_status_id
            },
        );
        }
    }
</script>